// extracted by css-extract-rspack-plugin
export default {"cls1":"JournalSubscriptionPage-cls1_lcD","cls2":"JournalSubscriptionPage-cls2_j9N JournalSubscriptionPage-cls1_lcD"};